module.exports = __webpack_public_path__ + "img/contrato.fab9d1d9.png";